import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RequestItem } from '@innowise-group/core';
import { Input } from '@innowise-group/mui-kit';
import { LabeledCheckbox } from '@shared-mui-components';

import { RequestFormViewProps } from '../../request-form.types';

type CommentSectionProps = Pick<RequestFormViewProps, 'disabled'>;

const CommentSection: React.FC<CommentSectionProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext<RequestItem>();

  return (
    <div>
      <Controller
        name="comment"
        control={control}
        render={({ field: { onChange, value }, formState: { errors } }) => (
          <Input
            fullWidth
            multiline
            rows={4}
            value={value}
            onChange={onChange}
            disabled={disabled}
            label={t('pages.candidates.candidateCreation.comment')}
            placeholder={t('pages.candidates.candidateCreation.addAComment')}
            error={!!errors?.comment?.message}
            helperText={errors?.comment?.message}
          />
        )}
      />
      <Controller
        name="isCommentRestricted"
        control={control}
        render={({ field: { onChange, value } }) => (
          <LabeledCheckbox
            onChange={onChange}
            checked={value}
            label={t('pages.requests.creationModal.restrictAccess')}
          />
        )}
      />
    </div>
  );
};

export default CommentSection;
